import React, { FC, useEffect, useState } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';
import {
  DisputesAlertProvidersFilters,
  IDisputesAlertProvidersFiltersProps,
} from '../../components/disputes-alert-providers/DisputesAlertProvidersFilters';
import { fetchWhiteListedPartnersList } from '../../store/merchnts/actions/partners';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import {
  fetchDisputesAlertProviders,
} from '../../store/payments/actions/disputes-alert-providers';
import { IDisputesAlertProviders } from '../../store/payments/payments-interfaces';

export const DisputesAlertProvidersList: FC = () => {
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

  const { merchantState, dispatch: merchantDispatch } = useMerchants();
  const { isPartnerNamesListLoading } = merchantState;

  const [partnerId, setPartnerId] = useState<string>('');
  const [isActive, setIsActive] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [disputesAlertProvidersData, setDisputesAlertProvidersData] = useState<IDisputesAlertProviders[]>([]);

  useEffect(() => {
    if (checkRoles(authUser, CLAIMS.SUPER_ADMIN)) {
      void fetchWhiteListedPartnersList(merchantDispatch);
    }
  }, []);

  const listener = async (search: IDisputesAlertProvidersFiltersProps): Promise<void> => {
    setLoading(true);

    if (Object.keys(search).length) {
      setPartnerId(search.partnerId ?? '');

      let localIsActive = '';

      switch (search?.isActive) {
        case 'true':
          localIsActive = '1';
          break;
        case 'false':
          localIsActive = '2';
          break;
        default:
          localIsActive = '';
          break;
      }
      setIsActive(localIsActive);
    }

    const data = await fetchDisputesAlertProviders(search);

    setDisputesAlertProvidersData(data);
    setLoading(false);
  };

  return (
    <>
      <DisputesAlertProvidersFilters
        partnerId={partnerId}
        isActive={isActive}
        setPartnerId={setPartnerId}
        setIsActive={setIsActive}
      />

      <Table
        name={TablesNames.disputesAlertProvidersTableData}
        data={disputesAlertProvidersData ?? []}
        isLoading={loading || isPartnerNamesListLoading}
        queryParamsListener={listener}
      />
    </>
  );
};